import { createContext, useMemo, useState } from 'react';
import { noop } from 'lodash-es';

import { pxToNumber } from '../../utils/cssUtils';
import { cssVariables } from '../../styles/cssVariables';

export const SplitterLeftPanelSizeContext = createContext({
  size: 0,
  setSize: noop,
});

export function getMinLeftPanelSize() {
  const gutter = pxToNumber(cssVariables.spaceNorm2);
  const innerWidth = pxToNumber(cssVariables.MonitorLeftColumn);

  return innerWidth + gutter;
}

export function SplitterLeftPanelSizeProvider({ children }) {
  const [size, setSize] = useState(getMinLeftPanelSize());
  const value = useMemo(() => ({ size, setSize }), [size]);

  return (
    <SplitterLeftPanelSizeContext.Provider value={value}>
      {children}
    </SplitterLeftPanelSizeContext.Provider>
  );
}
